import React from 'react'

const ToolbarBackButton = () => (
  <a
    onClick={() => {
      window.history.back()
    }}
  >
    <span className="material-icons md-36">arrow_back</span>
    <br />
    <span className="icon-text">Back</span>
  </a>
)

export default ToolbarBackButton



// WEBPACK FOOTER //
// ./src/Components/ToolbarBackButton.js